import React from "react";
import { Stack, Typography } from "@mui/material";

import WorkOrderLabel from "./WorkOrderLabel";
import {
  NotesStack,
  StyledMeltBox,
  StyledMeltBoxMetals,
  StyledMeltStack,
} from "./styles";
import { FINISHING_FILTERS } from "../../constants";
import { useStationListWithCache } from "../../components/StationHookFormSelect";
import { getWorkOrderInstructions } from "./helper";

const sx = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "7.5px",
};

const WorkOrderFoundry = ({ data }) => {
  // Foundry config carries per-section knobs; the first routing row owns the
  // station; material/tree are promoted onto the WO itself.
  const foundry = getWorkOrderInstructions(data, 4);
  const config = foundry?.config || {};
  const route = foundry?.routing?.[0];

  const filter = FINISHING_FILTERS[config?.filter - 1] || FINISHING_FILTERS[0];
  const { stations } = useStationListWithCache();
  const station =
    route?.stationId && stations?.find(({ id }) => id === route?.stationId);

  return (
    <StyledMeltStack>
      <Stack gap="5px">
        <StyledMeltBox>
          <Typography variant="boldCaptionMain">Melt Department</Typography>
          <WorkOrderLabel
            label="WRAP TREE"
            value={config?.wrapTree ? "✓" : ""}
            autoSpacing
          />
          <WorkOrderLabel
            label="HOT TOP"
            value={config?.hotTop ? "✓" : ""}
            autoSpacing
          />
          <WorkOrderLabel
            label="COVER"
            value={config?.cover ? "✓" : ""}
            autoSpacing
          />

          <WorkOrderLabel label="Station" value={station?.label} autoSpacing />
          <WorkOrderLabel label="HEAT NUMBER" underlined />
          <WorkOrderLabel
            label="METAL WT"
            value={`${config?.weight} lbs`}
            autoSpacing
          />
          <WorkOrderLabel label="FILTER" value={filter} autoSpacing />

          <WorkOrderLabel
            label="ALLOY"
            value={data?.material?.name}
            valueBold
          />
          <WorkOrderLabel
            label="SHELL TEMP"
            value={config?.shellTemp}
            autoSpacing
          />
          <WorkOrderLabel
            label="METAL TEMP"
            value={config?.metalTemp}
            autoSpacing
          />
          <WorkOrderLabel
            label="TREES/HEAT"
            value={config?.treesPerHeat}
            autoSpacing
          />
        </StyledMeltBox>
        <StyledMeltBoxMetals>
          <WorkOrderLabel label="ALLOY ADDS" />
          <Stack sx={sx}>
            <WorkOrderLabel label="FE SI" underlined />
            <WorkOrderLabel label="SI" underlined />
          </Stack>
          <Stack sx={sx}>
            <WorkOrderLabel label="FE MN" underlined />
            <WorkOrderLabel label="EL MN" underlined />
          </Stack>
          <WorkOrderLabel label="FE CR" underlined />

          <WorkOrderLabel label="ALL ADD" underlined />
          <Stack sx={sx}>
            <WorkOrderLabel label="Fe Ti" underlined />
            <WorkOrderLabel label="Ni" underlined />
          </Stack>
          <Stack sx={sx}>
            <WorkOrderLabel label="Alum" underlined />
            <WorkOrderLabel label="Mo" underlined />
          </Stack>
          <WorkOrderLabel label="Carbon" underlined />
        </StyledMeltBoxMetals>
      </Stack>
      <NotesStack col="4">
        <Typography variant="caption" fontWeight={400} lineHeight="14px">
          SPEC INST: <strong>{foundry?.notes}</strong>
        </Typography>
      </NotesStack>
    </StyledMeltStack>
  );
};

export default WorkOrderFoundry;
